import { useDispatch } from 'react-redux';

import { prefixWithUserProject } from 'utils/indexPageUtils';
import { updateNotesVisibility } from '../ducks';
import { useLocalStorage } from './useLocalStorage';

export const NOTES_VISIBILITY_LS_SUFFIX = 'isNotesVisible';

type IsNotesVisible = boolean;

export const useNotesVisibility = (): [IsNotesVisible, (arg: IsNotesVisible) => void] => {
  const dispatch = useDispatch();
  const isNotesVisibleKey = prefixWithUserProject(NOTES_VISIBILITY_LS_SUFFIX);
  // uses old local storage that doesn't dispatch
  const [isVisible, setIsVisibleLS] = useLocalStorage(isNotesVisibleKey, true);

  const setIsVisible = (e: boolean) => {
    dispatch(updateNotesVisibility(e));
    setIsVisibleLS(e);
  };

  return [isVisible, setIsVisible];
};
